
class custommediagallery extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
      $(this).css({ "opacity": 1, "visibility": "visible" });
      var swipernew = new Swiper(".mobile-thumnail-slider", {
        spaceBetween: 12.5,
        slidesPerView: 5,
        freeMode: true,
        loop: true,
        watchSlidesProgress: true,
      });
      var swiper2 = new Swiper(".product-media-slider", {
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next-product",
          prevEl: ".swiper-button-prev-product",
        },
        thumbs: {
          swiper: swipernew,
        },
      });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("custom-media-gallery", custommediagallery);

